"use strict";

var AssetFuelSummary = Backbone.Collection.extend({

    entity: 'Asset',
    filterKey: 'assetfuelsummary.filterParams',

    url: function() {
        var url;
        var params = { };
        url = Core.contextRoot + '/asset/assetfuelsummary';
        if (this.filterParams.from == null || typeof this.filterParams.from == 'undefined') {
            var fromDate = new Date();
            fromDate.setHours(0,0,0,0);
            fromDate.setDate(1);
            this.filterParams.from = fromDate.getTime();
        }
        params.from = this.filterParams.from;
        if (this.filterParams.to)
            params.to = this.filterParams.to;
        if (this.filterParams.states) params.states = this.filterParams.states.join(',');
        else params.states = 'FINISHED,DAY_FINISHED,CLOSED';
        var paramsStr = $.param(params);
        if (paramsStr.length > 0)
            url += '?' + paramsStr;
        return url;
    },
    
    initialize: function(models, options) {
        this.filterParams = options && options.filterParams || {};
    },

    loadFilter: function() {
        var storage = window.localStorage ? window.localStorage : window.sessionStorage;
        var filterParams = storage.getItem(this.filterKey);
        if (filterParams) {
            this.filterParams = JSON.parse(filterParams);
        }
        if (!this.filterParams.from) this.filterParams.from = new Date().setMonth(new Date().getMonth() - 1);
        if (!this.filterParams.states) this.filterParams.states = ['FINISHED', 'DAY_FINISHED', 'CLOSED'];
        if (!this.filterParams.assets) this.filterParams.assets = ['all', -1];
        if (!this.filterParams.customers) this.filterParams.customers = ['all', -1];
        if (!this.filterParams.customerProjects) this.filterParams.customerProjects = ['all', -1];
    },

    saveFilter: function() {
        var storage = window.localStorage ? window.localStorage : window.sessionStorage;
        storage.setItem(this.filterKey, JSON.stringify(this.filterParams));
    },
});

